(function () {
  'use strict';

  /* -------------------------------------------------------
   * Locate the element that holds individual review cards.
   * Strategy 1: try known Junip class names.
   * Strategy 2: pick the descendant with the most direct
   *             children (that is the review list).
   * ------------------------------------------------------- */
  function findReviewsContainer(widget) {
    var knownSelectors = [
      '.junip-reviews-container',
      '.junip-reviews-list',
      '.junip-reviews-grid',
      '[class*="reviews-container"]',
      '[class*="reviews-list"]',
      '[class*="reviews-layout"]',
      '[class*="reviews-grid"]'
    ];

    for (var i = 0; i < knownSelectors.length; i++) {
      var el = widget.querySelector(knownSelectors[i]);
      if (el && el.children.length >= 1) return el;
    }

    // Heuristic: element with the most direct children (require 3+ to avoid picking toolbar)
    var best = null;
    var bestCount = 2;
    var candidates = widget.querySelectorAll('div, ul, ol');
    for (var j = 0; j < candidates.length; j++) {
      var candidate = candidates[j];
      if (candidate.children.length > bestCount) {
        bestCount = candidate.children.length;
        best = candidate;
      }
    }
    return best;
  }

  /* -------------------------------------------------------
   * Build nav buttons and insert them before a track element.
   * ------------------------------------------------------- */
  function buildNav(track) {
    var nav = document.createElement('div');
    nav.className = 'junip-carousel-nav';
    nav.innerHTML =
      '<button class="junip-carousel-btn junip-carousel-btn--prev" aria-label="Previous reviews">' +
        '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
          '<path d="M12.5 15L7.5 10L12.5 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
        '</svg>' +
      '</button>' +
      '<button class="junip-carousel-btn junip-carousel-btn--next" aria-label="Next reviews">' +
        '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
          '<path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
        '</svg>' +
      '</button>';

    track.parentNode.insertBefore(nav, track);

    var prevBtn = nav.querySelector('.junip-carousel-btn--prev');
    var nextBtn = nav.querySelector('.junip-carousel-btn--next');

    function getScrollAmount() {
      var card = track.firstElementChild;
      if (!card) return 376;
      var style = window.getComputedStyle(track);
      var gap = parseFloat(style.gap) || parseFloat(style.columnGap) || 16;
      var cardsPerPage = window.innerWidth <= 600 ? 1 : 3;
      return (card.offsetWidth + gap) * cardsPerPage;
    }

    prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
    });

    function updateButtons() {
      prevBtn.disabled = track.scrollLeft < 5;
      nextBtn.disabled =
        track.scrollLeft + track.clientWidth >= track.scrollWidth - 5;
    }

    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons, { passive: true });
    updateButtons();

    // Hide nav arrows when there is only 1 review (nothing to scroll)
    if (track.children.length <= 1) {
      nav.style.display = 'none';
    }
  }

  /* -------------------------------------------------------
   * Apply carousel directly to a container element that
   * holds individual review cards (e.g. junip-reviews-container
   * rendered by the Junip app block).
   * ------------------------------------------------------- */
  function applyCarouselToContainer(container) {
    if (!container || container.classList.contains('junip-carousel-track')) return;
    container.classList.add('junip-carousel-track');
    buildNav(container);
  }

  /* -------------------------------------------------------
   * Convert the reviews container inside a widget into a
   * scrollable carousel and insert prev / next navigation.
   * ------------------------------------------------------- */
  function buildCarousel(widget) {
    var track = findReviewsContainer(widget);
    if (!track || track.classList.contains('junip-carousel-track')) return;
    track.classList.add('junip-carousel-track');
    buildNav(track);
  }

  /* -------------------------------------------------------
   * Watch a single junip-product-review widget and kick off
   * carousel construction once Junip has rendered its cards.
   * ------------------------------------------------------- */
  function initWidget(widget) {
    if (widget.querySelectorAll('div').length > 5) {
      setTimeout(function () { buildCarousel(widget); }, 400);
      return;
    }

    var observer = new MutationObserver(function (mutations, obs) {
      if (widget.querySelectorAll('div').length > 5) {
        obs.disconnect();
        setTimeout(function () { buildCarousel(widget); }, 400);
      }
    });

    observer.observe(widget, { childList: true, subtree: true });
  }

  /* -------------------------------------------------------
   * Watch any junip-reviews-container that appears in the DOM
   * (rendered by Junip app block) and convert to carousel.
   * ------------------------------------------------------- */
  function initContainer(container) {
    if (container.children.length >= 1) {
      setTimeout(function () { applyCarouselToContainer(container); }, 400);
      return;
    }

    var observer = new MutationObserver(function (mutations, obs) {
      if (container.children.length >= 1) {
        obs.disconnect();
        setTimeout(function () { applyCarouselToContainer(container); }, 400);
      }
    });

    observer.observe(container, { childList: true, subtree: true });
  }

  /* -------------------------------------------------------
   * Entry point
   * ------------------------------------------------------- */
  function init() {
    // Existing: watch .junip-product-review snippet widgets
    var widgets = document.querySelectorAll('.junip-product-review');
    for (var i = 0; i < widgets.length; i++) {
      initWidget(widgets[i]);
    }

    // New: watch .junip-reviews-container elements from app block
    var containers = document.querySelectorAll('.junip-reviews-container');
    for (var j = 0; j < containers.length; j++) {
      initContainer(containers[j]);
    }

    // Watch for dynamically injected .junip-reviews-container (app block renders async)
    var bodyObserver = new MutationObserver(function (mutations) {
      for (var m = 0; m < mutations.length; m++) {
        var added = mutations[m].addedNodes;
        for (var n = 0; n < added.length; n++) {
          var node = added[n];
          if (node.nodeType !== 1) continue;
          if (node.classList && node.classList.contains('junip-reviews-container')) {
            initContainer(node);
          }
          var inner = node.querySelector && node.querySelector('.junip-reviews-container');
          if (inner && !inner.classList.contains('junip-carousel-track')) {
            initContainer(inner);
          }
        }
      }
    });

    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
